module.exports = __webpack_public_path__ + "static/chilling.9c0792a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/chilling.svg
// module id = 125
// module chunks = 35783957827783 263791100135453